import * as actions from "../action.constants";

export const requestOTP = (data, callback) => ({
  type: actions.REQUEST_OTP,
  payload: data,
  callback,
});

export const validateOTP = (data, callback) => ({
  type: actions.VALIDATE_OTP,
  payload: data,
  callback,
});

export const verifyPhoneNumber = (data, callback) => ({
  type: actions.VERIFY_PHONE_NUMBER,
  payload: data,
  callback,
});
